import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="footer-ad"
export default class extends Controller {
  static targets = ["footer", "adOverlay"]

  connect() {
    this.handleScroll()
    this.setupAdEventListener()
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll.bind(this))
  }

  setupAdEventListener() {
    window.googletag = window.googletag || { cmd: [] }
    
    googletag.cmd.push(() => {
      googletag.pubads().addEventListener('slotRenderEnded', this.handleSlotRenderEnded.bind(this))
    })
  }

  handleSlotRenderEnded(e) {
    if (e.slot.getSlotElementId() === 'div-gpt-ad-1712641143269-0' && e.isEmpty === false) {
      this.updateFooterMargin()
    } else {
      if (this.hasAdOverlayTarget) {
        this.adOverlayTarget.classList.add('hidden')
        this.adOverlayTarget.classList.remove('flex')
      }
    }
  }

  handleScroll() {
    window.addEventListener('scroll', () =>{
      if (window.scrollY > 100) {
        this.updateFooterMargin()
      } else {
        if (this.hasAdOverlayTarget) {
          this.adOverlayTarget.classList.add('hidden')
          this.adOverlayTarget.classList.remove('flex')
        }
      }
    })
  }

  updateFooterMargin() {
    if (this.hasAdOverlayTarget && this.hasFooterTarget) {
      const height = this.adOverlayTarget.offsetHeight
      this.footerTarget.style.marginBottom = `${height/16}rem`
      this.adOverlayTarget.classList.add('flex')
      this.adOverlayTarget.classList.remove('hidden')
    }
  }

  handleAdClose() {
    this.updateFooterMargin()
  }
}
